module.exports = __webpack_public_path__ + "static/media/error-illustration.53da3d62.svg";